export default __webpack_public_path__ + "static/media/img-5.67158afa.jpg";